// Brand-as-config — single source of truth for the platform's user-facing name.
// Mirror of backend/brand.py. See docs/specs/BRANDING.md.
//
// Use BRAND_NAME for shared app chrome (logo wordmark, page title, login,
// emails) and for any new module's surrounding chrome. A module names *itself*
// with its own literal ("Recon", "CRM", "DMS"). Do NOT hardcode the platform
// name in components — reference BRAND_NAME so a rebrand is one env change.
//
// These are Create React App build-time env vars (REACT_APP_*), so changing
// them takes effect on the next frontend build/deploy, not at runtime.
// Defaults preserve "ReconFlow" until the env vars are set.
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'ReconFlow';
export const BRAND_DOMAIN = process.env.REACT_APP_BRAND_DOMAIN || 'goreconflow.com';
